import React from 'react';

const OUTCOME_COLORS = {
  Hold: '#94a3b8',
  cut: '#34d399',
  hike: '#f87171',
};

function pickColor(label) {
  if (label === 'Hold') return OUTCOME_COLORS.Hold;
  if (label.includes('cut')) return OUTCOME_COLORS.cut;
  if (label.includes('hike')) return OUTCOME_COLORS.hike;
  return '#60a5fa';
}

function fmtMeetingDate(iso) {
  const d = new Date(iso + 'T00:00:00Z');
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', timeZone: 'UTC' });
}

function FOMCMeetingCard({ meeting }) {
  if (!meeting) return null;
  const { meeting_date, year, has_sep, has_market, outcomes, polymarket_url } = meeting;
  const top = outcomes?.[0];

  return (
    <div className="bg-gray-900 border border-gray-700 rounded-lg p-4 h-full flex flex-col">
      <div className="flex items-start justify-between mb-2">
        <div>
          <div className="text-2xl font-bold text-white">{fmtMeetingDate(meeting_date)}</div>
          <div className="text-xs text-gray-500">{year}</div>
        </div>
        {has_sep && (
          <span className="text-[10px] uppercase tracking-wide px-2 py-0.5 rounded bg-indigo-900/30 text-indigo-300">
            SEP
          </span>
        )}
      </div>

      {has_market ? (
        <>
          {top && (
            <div className="mb-3">
              <div className="text-xs text-gray-400">Market consensus</div>
              <div className="text-lg font-semibold" style={{ color: pickColor(top.label) }}>
                {top.label} · {top.probability_pct.toFixed(1)}%
              </div>
            </div>
          )}
          <div className="space-y-1.5 flex-1">
            {outcomes.map((o) => {
              const color = pickColor(o.label);
              return (
                <div key={o.label}>
                  <div className="flex justify-between text-[11px] text-gray-300 mb-0.5">
                    <span>{o.label}</span>
                    <span>{o.probability_pct.toFixed(1)}%</span>
                  </div>
                  <div className="h-1.5 bg-gray-800 rounded overflow-hidden">
                    <div
                      className="h-full rounded"
                      style={{ width: `${Math.min(100, o.probability_pct)}%`, background: color }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          {polymarket_url && (
            <a
              href={polymarket_url}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 text-[11px] text-blue-300 hover:text-blue-200"
            >
              View on Polymarket ↗
            </a>
          )}
        </>
      ) : (
        <div className="flex-1 flex items-center justify-center text-xs text-gray-500 italic">
          Markets not yet posted
        </div>
      )}
    </div>
  );
}

export default FOMCMeetingCard;
